import type { QueryClient } from "@tanstack/react-query";

import { PRICE_RUN_KEY } from "./api";
import { CUSTOMER_KEY } from "./customer";
import { KPI_KEY } from "./kpi";
import { EVAL_KEY } from "./strategies";

/**
 * The reads a change to the saved batch drops (C1 v1.41): the runs read itself; the strategy evaluation, which judges the
 * effective price a save or a remove changes (C2 v1.14); the Customer lens, whose anchor a saved Amazon UK line moves
 * (C2 v1.15); and the KPI reads, whose staged forecast is the batch (C2 v1.33, C1 v1.30). One list, called by every save
 * and every remove, in the New price box and in the commit review.
 */
export function invalidateBatch(client: QueryClient): void {
  void client.invalidateQueries({ queryKey: PRICE_RUN_KEY }); void client.invalidateQueries({ queryKey: EVAL_KEY });
  void client.invalidateQueries({ queryKey: CUSTOMER_KEY }); void client.invalidateQueries({ queryKey: KPI_KEY });
}
